import { useCallback, useMemo, useState } from 'react'

interface CoursesVariables {
  text: string
  perPage: number
  page: number
  sorts: string[]
}

export const usePaginationVariables = () => {
  const [variables, setVariables] = useState<CoursesVariables>({
    text: '',
    perPage: 10,
    page: 1,
    sorts: [],
  })

  const { text, perPage, page, sorts } = variables

  const setPerPage = useCallback(
    (value: number) => setVariables((prev) => ({ ...prev, perPage: value })),
    []
  )
  const setPage = useCallback(
    (value: number) => setVariables((prev) => ({ ...prev, page: value })),
    []
  )
  const setSorts = useCallback(
    (value: string[]) => setVariables((prev) => ({ ...prev, sorts: value })),
    []
  )

  const setText = useMemo(() => {
    let timeout: number
    return (text: string) => {
      clearTimeout(timeout)
      timeout = window.setTimeout(() => {
        setVariables((prev) => ({ ...prev, text, page: 1 }))
      }, 1000)
    }
  }, [setVariables])

  return {
    text,
    perPage,
    page,
    sorts,
    setPerPage,
    setPage,
    setSorts,
    setText,
  }
}
